<template>
  <div>
    <div class="login-page">
      <div class="ts-shadow-md ts-border ts-p-4 ts-bg-white ts-w-64 ts-rounded login-box">
        <div class="ts-w-full ts-flex ts-justify-center">
          <img src="@/assets/logo.png" alt width="150" />
        </div>
        <form @submit.prevent="login" class="margin-bottom-0">
          <div class="ts-mt-10">
            <div
              class="alert alert-danger fade show ts-mb-4"
              v-show="errorMessage != ''"
            >{{ errorMessage }}</div>
            <div class="form-group ts-mb-4">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center"
                  >
                    <i class="fas fa-user"></i>
                  </span>
                </div>
                <input
                  type="text"
                  placeholder="Username"
                  class="form-control form-control-md input-login"
                  :class="{ 'is-invalid': errors.has('username') }"
                  v-model="username"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('username')"
                >{{ errors.first('username') }}</div>
              </div>
            </div>
            <div class="form-group ts-mb-4">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center"
                  >
                    <i class="fas fa-key"></i>
                  </span>
                </div>
                <input
                  type="password"
                  placeholder="Password"
                  class="form-control form-control-md input-login"
                  :class="{ 'is-invalid': errors.has('password') }"
                  v-model="password"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('password')"
                >{{ errors.first('password') }}</div>
              </div>
            </div>
            <!-- <div class="form-group ts-mb-4">
                <select
                  v-model="guard"
                  class="form-control form-control-md input-login"
                  :class="{ 'is-invalid': errors.has('guard') }"
                >
                  <option value="ADMIN_GUARD_SECRET">Office Staff</option>
          
                </select>
                <div class="invalid-feedback" v-if="errors.has('guard')">
                  {{ errors.first('guard') }}
                </div>
            </div>-->
            <div class="ts-mt-5">
              <ts-button
                type="submit"
                class="btn btn-primary btn-block btn-md"
                :waiting="loggingIn"
              >Sign me in</ts-button>
            </div>
          </div>
        </form>
        <div class="ts-mt-32 ts-text-center ts-text-blue-500">
          <span>POWERED BY: TECHSTORE CREATIVE SOLUTIONS</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'Login',
  data() {
    return {
      username: null,
      password: null,
      guard: 'ADMIN_GUARD_SECRET',
      errors: new Errors(),
      errorMessage: '',
      loggingIn: false
    }
  },
  computed: {
    currentYear() {
      return moment().year()
    }
  },
  created() {
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  methods: {
    async login() {
      this.errors = new Errors()
      this.errorMessage = ''
      this.loggingIn = true

      try {
        await this.$store.dispatch('login', {
          username: this.username,
          password: this.password,
          guard: this.guard
        })
        this.$router.push(this.$route.query.redirectTo || { name: 'dashboard' })
      } catch (errorResponse) {
        if (errorResponse.errors) {
          this.errors = new Errors(errorResponse.errors)
        } else if (errorResponse.message) {
          this.errorMessage = errorResponse.message
        }
      }

      this.loggingIn = false
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  position: relative;
  display: flex;
  // background-blend-mode: multiply;
  // background-color: rgba(0, 0, 0, 0.05);
  justify-content: center;
  align-items: center;
  // background-position: top center;
  height: 100vh;
  width: 100vw;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url('../assets/login_bg.jpg');
    opacity: 0.2;
  }
}

.login-box {
  z-index: 60;
  width: 330px;
  min-height: 435px;
}

.input-login {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.promotional-box {
  @media (min-width: 992px) {
    width: 780px;
    height: 435px;
    background-image: url('../assets/front-cover-default.jpeg');
  }
}
</style>
